import { AvatarStackProps, AvatarStackItem } from '@procore/core-react/dist/_typedoc/AvatarStack/AvatarStack.types.json';
import * as React from 'react';
export default {
  AvatarStackProps,
  AvatarStackItem,
  React
};